import { render, staticRenderFns } from "./modal-html-custom-attributes.vue?vue&type=template&id=4d171d03&"
import script from "./modal-html-custom-attributes.vue?vue&type=script&lang=js&"
export * from "./modal-html-custom-attributes.vue?vue&type=script&lang=js&"
import style0 from "./modal-html-custom-attributes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports